import axios from 'axios';

export const dashboardMethodFavorites = {
    async loadFavoriteTiles() {
        try {
            const response = await axios({
                method: "get",
                url: this.baseAPIURL + "/apiv3/listfavoritetiles.json",
                headers: {
                    "auth": this.$store.getters.auth_token,
                }
            });

            if (response.data.result === 'success') {
                this.$store.commit('SET_FAVORITE_TILES', response.data.data);
                const starred = {};
                response.data.data.forEach(f => {
                    starred[f.tile_id] = true;
                });
                this.favStarred = starred;
            }
        } catch (error) {
            console.error('Failed to load favorite tiles:', error);
        }
    },

    toggleFavoriteTile(tileId, event) {
        if (event) {
            event.stopPropagation();
        }

        if (this.favStarred[tileId]) {
            this.favStarred = Object.assign({}, this.favStarred, { [tileId]: false });
            this.removeFavoriteTileAPI(tileId);
        } else {
            this.favStarred = Object.assign({}, this.favStarred, { [tileId]: true });
            this.addFavoriteTileAPI(tileId);
        }
    },

    async addFavoriteTileAPI(tileId) {
        try {
            const bodyFormData = new FormData();
            bodyFormData.append('tile_id', tileId);

            await axios({
                method: "post",
                url: this.baseAPIURL + "/apiv3/addfavoritetile.json",
                data: bodyFormData,
                headers: {
                    "auth": this.$store.getters.auth_token,
                    "Content-Type": "multipart/form-data"
                }
            });
        } catch (error) {
            console.error('Failed to add favorite:', error);
        }
    },

    async removeFavoriteTileAPI(tileId) {
        try {
            const bodyFormData = new FormData();
            bodyFormData.append('tile_id', tileId);

            await axios({
                method: "post",
                url: this.baseAPIURL + "/apiv3/removefavoritetile.json",
                data: bodyFormData,
                headers: {
                    "auth": this.$store.getters.auth_token,
                    "Content-Type": "multipart/form-data"
                }
            });
        } catch (error) {
            console.error('Failed to remove favorite:', error);
        }
    },

    findTileInfoById(tileId) {
        if (!this.active_pages) return null;
        for (const page of Object.values(this.active_pages)) {
            if (page.tiles) {
                const found = page.tiles.find(t => t.id === tileId);
                if (found) return found;
            }
        }
        return null;
    },
};
